module.exports = __webpack_public_path__ + "media/images/ZOOM 1-693988f9.png";